export const API_BASE_URL = {
  'production': 'https://eushow-service.yoyohr.com',
  // 'lan': 'http://192.168.1.124:8076',
  'lan': 'http://192.168.1.17:9908',
  'development': 'http://192.168.1.17:9908'
  // 'development': 'https://eushow-service.yoyohr.com'
}[process.env.NODE_ENV]

export const COOKIE_DOMAIN = {
  'production': 'yoyohr.com',
  'lan': 'youpin-k8s.net',
  'development': 'localhost'
}[process.env.NODE_ENV]

// token 名字
export const TOKEN_NAME = 'ideaspread_ams_token'



// WEBPACK FOOTER //
// ./src/config/index.js